import React from 'react';
import { X, FileSpreadsheet } from 'lucide-react';

const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Number.isInteger(value) ? String(value) : value.toFixed(2);
  }
  return String(value);
};

const FileDetailModal = ({ file, isOpen, onClose, sourceFileName }) => {
  if (!isOpen || !file) return null;

  const detailItems = [
    { label: 'Esas No', value: file.esasNo },
    { label: 'Suç Türü', value: file.sucTuru },
    { label: 'Sanık Sayısı', value: file.sanikSayisi },
    { label: 'Mağdur Sayısı', value: file.magdurSayisi },
    { label: 'Klasör Sayısı', value: file.klasorSayisi },
    { label: 'Tebliğname Görüşü', value: file.gorus },
    { label: 'Eski Hakim', value: file.eskiHakim || '-' },
    { label: 'Manuel Tevzi Edilecek Hakim', value: file.manuelTevziEdilecekHakim || '-' },
    { label: 'Dosya Puanı', value: file.dosyaPuani },
    { label: 'Atanan Hakim', value: file.atananHakim || '-' },
  ];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="file-detail-modal-title"
    >
      <button
        type="button"
        className="absolute inset-0 bg-slate-900/45 backdrop-blur-[2px] transition-opacity"
        aria-label="Kapat"
        onClick={onClose}
      />
      <div
        className="relative flex max-h-[min(90vh,720px)] w-full max-w-xl flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-2xl shadow-slate-900/10"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative border-b border-slate-100 bg-gradient-to-br from-slate-50 via-white to-indigo-50/40 px-5 py-4 sm:px-6">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="text-xs font-medium uppercase tracking-wider text-indigo-600/90">
                Dosya bilgisi
              </p>
              <h2
                id="file-detail-modal-title"
                className="mt-1 truncate text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl"
                title={file.esasNo != null ? String(file.esasNo) : undefined}
              >
                {file.esasNo != null ? String(file.esasNo) : 'Dosya detayları'}
              </h2>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-slate-500 transition hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              aria-label="Kapat"
            >
              <X size={20} strokeWidth={2} />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4 sm:px-6">
          <dl className="grid gap-2">
            {detailItems.map((item) => (
              <div
                key={item.label}
                className="grid grid-cols-1 gap-0.5 rounded-xl border border-slate-100 bg-slate-50/60 px-3 py-2.5 sm:grid-cols-[minmax(0,38%)_1fr] sm:items-baseline sm:gap-4 sm:py-2"
              >
                <dt className="text-xs font-medium text-slate-500 sm:text-sm">{item.label}</dt>
                <dd className="text-sm font-medium text-slate-900 sm:text-right sm:text-[15px]">
                  {formatValue(item.value)}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        {sourceFileName ? (
          <div className="border-t border-slate-100 bg-slate-50/90 px-5 py-3 sm:px-6">
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-slate-600 sm:text-sm">
              <FileSpreadsheet className="h-4 w-4 shrink-0 text-emerald-600" aria-hidden />
              <span className="font-medium text-slate-500">Kaynak liste:</span>
              <span
                className="min-w-0 flex-1 truncate font-medium text-slate-800 sm:text-right"
                title={sourceFileName}
              >
                {sourceFileName}
              </span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FileDetailModal;
